"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _utils = require("./../utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var ThemeContext = /*#__PURE__*/_react["default"].createContext({});
var children;
var tabKey = 0;
var TabPane = function TabPane(props) {
  var key = props.key,
    tabIndex = props.tabIndex,
    title = props.title,
    record = props.record,
    onTabClick = props.onTabClick;
  var value = (0, _react.useContext)(ThemeContext);
  var compute = function compute() {
    var childrenParentNodes = value.inputEl.current;
    var childrenNodes = childrenParentNodes ? childrenParentNodes.childNodes || [] : [];
    // todo optimize
    for (var i = 0; i < childrenNodes.length - 1; i++) {
      if (i == 0) {
        if (childrenNodes[i].childNodes[0]) {
          var childrenElementWidth = childrenNodes[i].clientWidth;
          childrenNodes[childrenNodes.length - 1].style.width = childrenElementWidth + "px";
        }
        childrenNodes[i].className = 'ant-tabs-tab ant-tabs-tab-active';
      }
    }
  };
  var tabBor = function tabBor() {
    var childrenParentNodes = value.inputEl.current;
    var childrenNodes;
    if (children && children.childNodes) {
      childrenNodes = children.childNodes;
    } else {
      childrenNodes = childrenParentNodes ? childrenParentNodes.childNodes || [] : [];
    }
    // todo optimize
    if (childrenNodes[tabKey] && childrenNodes[tabKey].childNodes && childrenNodes[tabKey].childNodes[0]) {
      var childrenElementWidth = childrenNodes[tabKey].clientWidth;
      var elementWidth = childrenNodes[tabKey] && childrenNodes[tabKey];
      var elementWidth_child_width = elementWidth ? elementWidth.offsetLeft : 0;
      childrenNodes[childrenNodes.length - 1].style.left = elementWidth_child_width + "px";
      childrenNodes[childrenNodes.length - 1].style.width = childrenElementWidth + "px";
    }
  };
  (0, _react.useEffect)(function () {
    compute();
    window.addEventListener('resize', tabBor);
  }, []);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('ant-tabs-tab', {
      // 'ant-tabs-tab-active': classStatus
    }),
    "report-event": "click_tab_button",
    "report-ext1": tabIndex,
    "report-ext2": title || '',
    onClick: function onClick(event) {
      onTabClick && onTabClick(record, tabIndex, event);
      if (value.onCallback) {
        value.onCallback(props);
      }
      var childrenParentNodes = value.inputEl.current;
      children = childrenParentNodes;
      var controlTabs = value.inputElCont.current;
      // const controlTabs = document.getElementById('ant-tabs-content-holder') || {} as any;
      var childrenNodes = childrenParentNodes ? childrenParentNodes.childNodes || [] : [];
      var childrenNodesControlTabs = controlTabs ? controlTabs.childNodes || [] : [];
      // todo optimize
      for (var i = 0; i < childrenNodes.length - 1; i++) {
        if (i == tabIndex - 1) {
          tabKey = i;
          var elementWidth = childrenNodes[i] && childrenNodes[i];
          var elementWidth_child_width = elementWidth ? elementWidth.offsetLeft : 0;
          // console.log(elementWidth_child_width,'elementWidth_child_width',elementWidth.offsetLeft)
          childrenNodes[childrenNodes.length - 1].style.left = elementWidth_child_width + "px";
          if (childrenNodes && childrenNodes[i] && childrenNodes[i].childNodes && childrenNodes[i].childNodes[0]) {
            var childrenElementWidth = childrenNodes[i].clientWidth;
            childrenNodes[childrenNodes.length - 1].style.width = childrenElementWidth + 12 + "px";
          }
          if (childrenNodesControlTabs[i] && childrenNodesControlTabs[i].style) {
            childrenNodesControlTabs[i].style.display = 'block';
          }
          childrenNodes[i].className = 'ant-tabs-tab ant-tabs-tab-active';
        } else {
          if (childrenNodesControlTabs[i] && childrenNodesControlTabs[i].style) {
            childrenNodesControlTabs[i].style.display = 'none';
          }
          childrenNodes[i].className = 'ant-tabs-tab ';
        }
      }
    },
    key: key
  }, /*#__PURE__*/_react["default"].createElement("div", {
    role: "tab",
    "aria-selected": "true",
    className: 'ant-tabs-tab-btn',
    id: "rc-tabs-0-tab-1",
    "aria-controls": "rc-tabs-0-panel-1"
  }, title)));
};
var Tabs = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var icon = props.icon,
    banner = props.banner,
    sharp = props.sharp,
    radius = props.radius,
    source = props.source,
    className = props.className,
    children = props.children,
    onClick = props.onClick,
    onCallback = props.onCallback,
    onTabClick = props.onTabClick,
    record = props.record,
    restProps = __rest(props, ["icon", "banner", "sharp", "radius", "source", "className", "children", "onClick", "onCallback", "onTabClick", "record"]);
  var collectChildren = [];
  // const _requestAnimationFrame = (getInnerChild_1?: any, deadline?: any) => {
  //   valDirectionRight = deadline > getInnerChild_1.scrollLeft;
  //   runRequestFunc(getInnerChild_1, deadline);
  // };
  // const moveToNode = () => {
  //   const getInnerChild: any = innerRef.current;
  //   const getInnerChild_1 = getInnerChild.childNodes[0] as any;
  //   return getInnerChild_1;
  // };
  // const moveToFunc = (deadline?: any) => {
  //   _requestAnimationFrame(moveToNode(), deadline);
  // };
  _react.Children.forEach(children, function (item) {
    var _ = item ? item.props : null;
    collectChildren.push(_.children);
  });
  var inputEl = (0, _react.useRef)(null);
  var inputElCont = (0, _react.useRef)(null);
  var innerRef = (0, _react.useRef)(null);
  var leftRef = (0, _react.useRef)(null);
  var rightRef = (0, _react.useRef)(null);
  var val = {
    x: 0
  };
  var scale = 0.1;
  var valDirectionRight = true;
  var _runRequestFunc = function runRequestFunc(getInnerChild_1, deadline, currentScroll) {
    requestAnimationFrame(function () {
      if (!rightRef.current || !leftRef.current) return;
      val = (0, _utils.animates)({
        x: currentScroll || getInnerChild_1.scrollLeft
      }, deadline);
      if (val.x > getInnerChild_1.scrollWidth - getInnerChild_1.clientWidth) {
        rightRef.current.style.display = 'none';
      } else {
        rightRef.current.style.display = 'block';
      }
      if (val.x < 10) {
        leftRef.current.style.display = 'none';
      } else {
        leftRef.current.style.display = 'block';
      }
      getInnerChild_1.scrollLeft = val.x;
      if (valDirectionRight && deadline - val.x > scale) {
        _runRequestFunc(getInnerChild_1, deadline, Math.fround(val.x));
      } else if (!valDirectionRight && deadline - val.x < -scale) {
        _runRequestFunc(getInnerChild_1, deadline, Math.fround(val.x));
      }
      displayRight();
    });
  };
  var _requestAnimationFrame = function _requestAnimationFrame(getInnerChild_1, deadline) {
    valDirectionRight = deadline > getInnerChild_1.scrollLeft;
    _runRequestFunc(getInnerChild_1, deadline);
  };
  var moveToNode = function moveToNode() {
    var getInnerChild = innerRef.current;
    var getInnerChild_1 = getInnerChild && getInnerChild.childNodes && getInnerChild.childNodes[0];
    return getInnerChild_1;
  };
  var moveToFunc = function moveToFunc(deadline) {
    _requestAnimationFrame(moveToNode(), deadline);
  };
  var displayRight = function displayRight() {
    if (!rightRef.current) return;
    if (moveToNode().scrollWidth <= 1392) {
      rightRef.current.style.display = 'none';
    }
  };
  (0, _react.useEffect)(function () {
    if (val.x < 10 && leftRef && leftRef.current && leftRef.current.style) {
      leftRef.current.style.display = 'none';
    }
    displayRight();
  }, []);
  return /*#__PURE__*/_react["default"].createElement("div", __assign({
    ref: ref,
    className: (0, _classnames["default"])('flex-default-flex-default-Tab', className)
  }, restProps), /*#__PURE__*/_react["default"].createElement(ThemeContext.Provider, {
    value: {
      inputEl: inputEl,
      inputElCont: inputElCont,
      collectChildren: collectChildren,
      onCallback: onCallback
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'ant-tabs'
  }, collectChildren && collectChildren.length > 1 ? (/*#__PURE__*/_react["default"].createElement("div", {
    className: 'tab-list',
    ref: innerRef
  }, /*#__PURE__*/_react["default"].createElement("div", {
    ref: inputEl,
    className: 'ant-tabs-list-copy'
  }, _react.Children.map(children, function (item) {
    return item;
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: 'ant-tabs-ink-bar ant-tabs-ink-bar-animated',
    style: {
      left: 0,
      width: '36px'
    }
  })))) : (/*#__PURE__*/_react["default"].createElement("div", {
    className: 'tab-list',
    ref: innerRef,
    style: {
      display: 'none'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    ref: inputEl,
    className: 'ant-tabs-list-copy'
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: 'left',
    ref: leftRef
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'mc-left'
  }), /*#__PURE__*/_react["default"].createElement("img", {
    onClick: function onClick() {
      moveToFunc(moveToNode().scrollLeft - 300);
    },
    src: 'https://main.qcloudimg.com/qcintl-cms/154/1624937747927/b05f213ab6e01c8e7fe45def71cf4776.svg'
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: 'right',
    ref: rightRef
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'mc-right'
  }), /*#__PURE__*/_react["default"].createElement("img", {
    onClick: function onClick(e) {
      e.preventDefault();
      moveToFunc(moveToNode().scrollLeft + 300);
    },
    src: 'https://main.qcloudimg.com/qcintl-cms/154/1624937747927/b05f213ab6e01c8e7fe45def71cf4776.svg'
  })), /*#__PURE__*/_react["default"].createElement("div", {
    ref: inputElCont,
    className: 'ant-tabs-content-holder'
  }, _react.Children.map(collectChildren, function (item) {
    return item;
  })))));
});
Tabs.displayName = 'TCITabs';
Tabs.TabPane = TabPane;
var _default = exports["default"] = Tabs;